__turbopack_context__.v({
  "actions": "PlasmicCalloutSectionTextColumn-module__i9pkHa__actions",
  "button": "PlasmicCalloutSectionTextColumn-module__i9pkHa__button",
  "button2": "PlasmicCalloutSectionTextColumn-module__i9pkHa__button2",
  "button__bo8Fw": "PlasmicCalloutSectionTextColumn-module__i9pkHa__button__bo8Fw",
  "col": "PlasmicCalloutSectionTextColumn-module__i9pkHa__col",
  "header": "PlasmicCalloutSectionTextColumn-module__i9pkHa__header",
  "heading": "PlasmicCalloutSectionTextColumn-module__i9pkHa__heading",
  "svg__cnwxa": "PlasmicCalloutSectionTextColumn-module__i9pkHa__svg__cnwxa",
  "svg__exemg": "PlasmicCalloutSectionTextColumn-module__i9pkHa__svg__exemg",
  "svg__fbnLw": "PlasmicCalloutSectionTextColumn-module__i9pkHa__svg__fbnLw",
  "svg__irzKw": "PlasmicCalloutSectionTextColumn-module__i9pkHa__svg__irzKw",
  "svg__jlSkZ": "PlasmicCalloutSectionTextColumn-module__i9pkHa__svg__jlSkZ",
  "svg__ze6QT": "PlasmicCalloutSectionTextColumn-module__i9pkHa__svg__ze6QT",
  "text": "PlasmicCalloutSectionTextColumn-module__i9pkHa__text",
  "text__cjyfa": "PlasmicCalloutSectionTextColumn-module__i9pkHa__text__cjyfa",
  "text__pGDx": "PlasmicCalloutSectionTextColumn-module__i9pkHa__text__pGDx",
  "text__wsCq3": "PlasmicCalloutSectionTextColumn-module__i9pkHa__text__wsCq3",
});
